import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { ParmedApiService as ParmedApi } from '../api/parmed-api.service';
import { AppUtilService } from '../utils/app-util.service';
import { RequestHeaders, CacheConstant } from '../constants/app.constant';
import { AppCacheService } from './cache/app-cache.service';

@Injectable()
export class AnalyticsService {
  /*********************Constructor*********************/
  constructor(private http: HttpService, private api: ParmedApi, private cache: AppCacheService) {}
  /*********************Constructor*********************/

  /*********************Service Methods*********************/

  getServerDate() {
    const defaultOptions = AppUtilService.getHttpDefaultOptions();
    defaultOptions.headers['Accept'] = 'application/json';

    return this.http.get(
      this.api.Config.GET_SERVER_DATETIME_URL,
      defaultOptions
    );
  }

  
  getMetaInfo() {
    const defaultOptions = AppUtilService.getHttpDefaultOptions();
    defaultOptions.headers['Accept'] = 'application/json';

    return this.http.get(
      this.api.Config.GET_SERVER_METAINFO_URL + '/' + this.cache.get(CacheConstant.Env_Properties).buId,
      defaultOptions
    );
  }


  /*********************Service Methods*********************/
}
